import { RootState } from '@core/redux/reducers';
import { BreadcrumbItem } from '@features/layout/store/layout.slice';

export const selectCurrentLayout = (state: RootState): 'auth' | 'application' =>
  state.layout.layout;

export const selectIsSidebarCollapsed = (state: RootState): boolean =>
  state.layout.isSidebarCollapsed;

export const selectCurrentBreadcrumbs = (state: RootState): BreadcrumbItem[] =>
  state.layout.breadcrumbs;
